export const FileUploadStatus = {
  IN_PROGRESS: 'in-progress' as const,
  COMPLETED: 'completed' as const,
  ERROR: 'error' as const,
  PAUSED: 'paused' as const,
  FILE_SIZE_EXCEEDED: 'file-size-exceeded' as const,
  PASSWORD_PROTECTED: 'password-protected' as const,
};
